/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {ChartComponent as ɵa} from './chart.component';